import { post } from './fetch';
import appConfig from '../../config';

const systemLoginCall = (token) => {
  return post(appConfig.endpoints.systemLogin, { user_token: token })
}

export default systemLoginCall;